import React from "react"
import "../Sass/home.css"
import SocialIcon from "../Components/SocialsIcon"
import Navbar from "../Components/Navbar"

const Home = () => {
  const handleNavClick = (e) => {
    let pageName = e.target.innerText.toLowerCase()
    const headerHeight = 40

    const ele = document.querySelector(`#${pageName}`)
    const buffer = 45
    const topOfElement =
      window.pageYOffset +
      ele.getBoundingClientRect().top -
      headerHeight -
      buffer
    window.scroll({ top: topOfElement, behavior: "smooth" })
  }

  return (
    <>
      <section id="home">
        <div className="landing text-center py-5">
          <h1 className="display-2 main__heading">Welcome to my Portfolio</h1>
          <h1 className="display-1 sub__heading pt-2">It's Nice To Meet You</h1>
          <h2>
            I'm Hardik. I Love <span className="type"></span>
          </h2>
          <div className="row px-md-5 px-lg-0 py-5 mx-auto">
            <SocialIcon />
          </div>
        </div>
      </section>
      <Navbar handleClick={handleNavClick} />
    </>
  )
}

export default Home
